import * as React from "react";
import { useIntl, useDispatch, useSelector } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../StepShipping/actions.js";
import { getContactDetailsFormData, isPrefillFinished } from "../../../StepShipping/selectors.js";
import { TitleWithIcon } from "../../../../components/TitleWithIcon/components/TitleWithIcon/TitleWithIcon.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const ContactDetailsContainer = () => {
  const { getLabel } = useIntl();
  const dispatch = useDispatch();
  const isContactFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ContactDetails);
  const contactDetailsInitialData = useSelector(getContactDetailsFormData);
  const isPrefillFinished$1 = useSelector(isPrefillFinished);
  const handleChange = React.useCallback(
    (formData) => {
      dispatch(updateShippingDetails({ form: formData }));
    },
    [dispatch]
  );
  if (!isContactFormAvailable) return null;
  if (!contactDetailsInitialData || !isPrefillFinished$1) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TitleWithIcon, { icon: "address-book", label: getLabel("checkout.shipping.details.title") }), /* @__PURE__ */ React.createElement(
    CheckoutForm,
    {
      formName: "contactDetails",
      "data-t": "contactDetails",
      initialFormState: contactDetailsInitialData,
      onChange: handleChange
    },
    /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.ContactDetails })
  ));
};
export {
  ContactDetailsContainer
};
//# sourceMappingURL=ContactDetailsContainer.js.map
